import { Controller } from "@hotwired/stimulus"

// Maneja la logica de "Todos" vs selección individual de calendarios
// en el modal de configuracion de Google Calendar.
//
// - Click "Todos" marcado: desmarca todos los individuales.
// - Click individual marcado: desmarca "Todos".
// - Todos los individuales desmarcados: marca "Todos".
export default class extends Controller {
  static targets = ["all", "item"]

  toggleAll() {
    if (this.allTarget.checked) {
      this.itemTargets.forEach((item) => { item.checked = false })
    }
  }

  toggleItem(event) {
    if (event.target.checked) {
      this.allTarget.checked = false
    } else if (this.itemTargets.every((i) => !i.checked)) {
      this.allTarget.checked = true
    }
  }
}
